var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@mui/material/styles/styled';
import { TableHead, TableRow } from '@mui/material';
import TheadCell from './TheadCell';
var TableHeadRoot = styled(TableHead)({
    backgroundColor: '#fafafa',
    position: 'relative',
});
var FbmThead = function (_a) {
    var data = _a.data, columns = _a.columns, nameText = _a.nameText, batchActions = _a.batchActions;
    return (React.createElement(TableHeadRoot, null,
        React.createElement(TableRow, null, columns.map(function (columnItem) {
            return (React.createElement(TheadCell, __assign({ key: columnItem.id, data: data, batchActions: batchActions, nameText: nameText }, columnItem)));
        }))));
};
export default FbmThead;
